import {
    inject,
    ObjectGraph,
} from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';

import { DependencyType } from '../../dependencies/dependency-type';
// import type { FlowAction } from "../../models";
// import { isNone } from "../../util/optional";

import type { RouterResponse, RouteUrlIntent } from './intent';
import { isRouteableIntent } from '../common/routeable-intent';

export const RouteUrlIntentController: IntentController<RouteUrlIntent> = {
    $intentKind: 'RouteUrlIntent',

    async perform(
        intent: RouteUrlIntent,
        objectGraph: ObjectGraph,
    ): Promise<RouterResponse | undefined> {
        const router = inject(DependencyType.ROUTER, objectGraph);
        const targetIntent = router.intentFor(intent.url);
        // debugger;

        if (!targetIntent) {
            return;
        }

        if (isRouteableIntent(targetIntent)) {
            return {
                // intent needed for SSR
                intent: targetIntent,
                // only ever used by client; only clients have actions
                action: {
                    $kind: 'flowAction',
                    destination: targetIntent,
                    actionMetrics: { data: [], custom: {} },
                },
                storefront: targetIntent.storefront,
                language: targetIntent.language,
            };
        }

        // All intents returned by `router.intentFor` should be
        // `RouteableIntents`s, but in case one isn't, we fall back to the bag
        // for defaults.
        // const bag = inject(DependencyType.BAG, objectGraph);
        return null;
    },
};
